export default "__VITE_ASSET__C$AcrVVn__"